import BaseAgencyScopeEntityDto from '@/models/Shared/BaseAgencyScopeEntityDto';
import RateCardPositionDto from '@/models/RateCardPositions/RateCardPositionDto';

export default class RateCardDto extends BaseAgencyScopeEntityDto {
    status = 0;
    name = '';
    driverUnitExpenseChargeRate = 0;
    positions: RateCardPositionDto[] = [];
}